import { useRef } from 'react';

/**
 * Creates a stable function against the passed function that can be checked
 * for shallow equality while having access to values in scope
 * Required for callbacks to guarantee referential equality
 */
export const useStableFunction = fn => {
  const currentFnRef = useRef(fn);
  const stableFnRef = useRef(undefined);
  currentFnRef.current = fn;
  if (!stableFnRef.current) {
    stableFnRef.current = function (...args) {
      return currentFnRef.current.call(this, ...args);
    };
  }
  return stableFnRef.current;
};